"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrateAccountBody = exports.CancelVCCResponse = exports.CancelVCCBody = exports.GetCardDetailsResponse = exports.ProvisionVCCResponse = exports.ProvisionVCCBody = exports.ExchangePlaidTokenResponse = exports.ExchangePlaidTokenBody = exports.CreatePlaidLinkTokenResponse = exports.CreatePlaidLinkTokenBody = void 0;
const typebox_1 = require("@sinclair/typebox");
/**
 * Transport types for vendor onboarding endpoints
 *
 * These types define the API contracts for:
 * - Plaid Link token generation
 * - Plaid public token exchange
 * - Vendor payment profile retrieval
 * - Virtual credit card provisioning
 */
// ============================================================================
// Plaid Link Token Generation
// ============================================================================
exports.CreatePlaidLinkTokenBody = typebox_1.Type.Object({
    haulerName: typebox_1.Type.Optional(typebox_1.Type.String({ description: 'Business name for display in Plaid Link' })),
});
exports.CreatePlaidLinkTokenResponse = typebox_1.Type.Object({
    linkToken: typebox_1.Type.String({ description: 'Plaid Link token (expires in 30 minutes)' }),
    expiration: typebox_1.Type.String({ description: 'ISO 8601 expiration timestamp' }),
});
// ============================================================================
// Plaid Token Exchange
// ============================================================================
exports.ExchangePlaidTokenBody = typebox_1.Type.Object({
    publicToken: typebox_1.Type.String({ description: 'Public token from Plaid Link' }),
    institutionID: typebox_1.Type.Optional(typebox_1.Type.String({ description: 'Plaid institution ID from Link onSuccess metadata' })),
});
exports.ExchangePlaidTokenResponse = typebox_1.Type.Object({
    profileID: typebox_1.Type.String({ format: 'uuid', description: 'Vendor payment profile ID' }),
    accountMask: typebox_1.Type.String({ description: 'Last 4 digits of bank account' }),
    accountType: typebox_1.Type.String({ description: 'Account type (checking/savings)' }),
    status: typebox_1.Type.String({ description: 'Profile status' }),
});
// ============================================================================
// Virtual Credit Card Provisioning
// ============================================================================
exports.ProvisionVCCBody = typebox_1.Type.Object({
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'uuid',
        description: 'Target vendor ID (required for alliance-customer-service, optional for hauler-admin)',
    })),
    spendingLimit: typebox_1.Type.Optional(typebox_1.Type.Integer({
        minimum: 0,
        default: 0,
        description: 'Maximum spend amount in cents (defaults to $0 for security)',
    })),
    linkedInvoiceIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }), {
        description: 'Invoice IDs this card is restricted to',
    })),
    notes: typebox_1.Type.Optional(typebox_1.Type.String({ description: 'Notes about this card' })),
});
exports.ProvisionVCCResponse = typebox_1.Type.Object({
    vccID: typebox_1.Type.String({ format: 'uuid', description: 'Virtual credit card ID' }),
    svbCardId: typebox_1.Type.String({ format: 'uuid', description: 'SVB VCN card UUID' }),
    last4: typebox_1.Type.String({ description: 'Last 4 digits of card' }),
    spendingLimit: typebox_1.Type.Integer({ description: 'Spending limit in cents' }),
    status: typebox_1.Type.String({ description: 'Card status' }),
});
exports.GetCardDetailsResponse = typebox_1.Type.Object({
    cardNumber: typebox_1.Type.String({ description: 'Full 16-digit card number' }),
    cvc: typebox_1.Type.String({ description: '3-digit CVC' }),
    last4: typebox_1.Type.String({ description: 'Last 4 digits' }),
    expiry: typebox_1.Type.String({ description: 'YYYY-MM format' }),
    status: typebox_1.Type.String({ description: 'Card status (APPROVED/CANCELED)' }),
    availableBalance: typebox_1.Type.Optional(typebox_1.Type.Integer({ description: 'Available balance in cents' })),
});
// ============================================================================
// Virtual Credit Card Cancellation
// ============================================================================
exports.CancelVCCBody = typebox_1.Type.Object({
    vendorID: typebox_1.Type.String({ format: 'uuid', description: 'Vendor whose virtual card should be canceled' }),
});
exports.CancelVCCResponse = typebox_1.Type.Object({
    vccID: typebox_1.Type.String({ format: 'uuid', description: 'Virtual credit card ID' }),
    svbCardID: typebox_1.Type.String({ format: 'uuid', description: 'SVB VCN card UUID' }),
    status: typebox_1.Type.String({ description: 'Card status after cancellation (TERMINATED)' }),
    revertedPayoutIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }), {
        description: 'In-flight payouts rolled back to PENDING_APPROVAL because the card was canceled',
    })),
});
// ============================================================================
// Plaid Account Migration
// ============================================================================
exports.MigrateAccountBody = typebox_1.Type.Object({
    vendorID: typebox_1.Type.String({ format: 'uuid', description: 'Vendor/hauler ID to create payment profile for' }),
    accountNumber: typebox_1.Type.String({ minLength: 4, maxLength: 17, description: 'Bank account number' }),
    routingNumber: typebox_1.Type.String({ pattern: '^[0-9]{9}$', description: '9-digit ACH routing number' }),
    accountType: typebox_1.Type.Union([typebox_1.Type.Literal('checking'), typebox_1.Type.Literal('savings')], {
        description: 'Bank account type',
    }),
    accountName: typebox_1.Type.Optional(typebox_1.Type.String({ description: 'Friendly name for the account (defaults to "Migrated Account")' })),
});
//# sourceMappingURL=vendor-onboarding-transport.js.map